import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';

const AddPackage = () => {

      const [responseMessage, setResponseMessage] = useState('');
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    pac_name: '',
    night: '',
    day: '',
    start_point: '',
    dest_point: '',
    sightseeing: '',
    accomodation: '',
    meal: '',
    vehicle: '',
    pac_price: '',
    description: '',
    image: null
  })

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    payload.append(key, value);
  });

  try {
    const response = await axios.post('https://api.shaktitours.com/add-package', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    if (response.status === 200) {
                setResponseMessage('New Package Added successfully!');
                setFormData({
                      pac_name: '',
    night: '',
    day: '',
    start_point: '',
    dest_point: '',
    sightseeing: '',
    accomodation: '',
    meal: '',
    vehicle: '',
    pac_price: '',
    description: '',
    image: null
                })
                setTimeout(() => {
                    setResponseMessage('');
                }, 3000);

    } else {
                setResponseMessage('Failed to add new package.');
                setTimeout(() => {
                    setResponseMessage('');
                }, 3000);
    }
  } catch (error) {
    console.error('Error submitting package:', error);
  }
};


  return (
    <>
      <section className='my-5'>
        <div className='container'>
          <button className='nav-btn bg-black mb-4' onClick={() => navigate('/dashboard')}>
            <i className="fa-solid fa-arrow-left"></i> Back
          </button>

          <div className='package-area col-lg-8 mx-auto col-12 my-md-4 my-2'>

          <p className='sec-heading fs-5'>Add New Package</p>
          <hr />

<form onSubmit={handleSubmit} encType="multipart/form-data" className="row g-3">

  <div className="col-12">
    <label className='package-label'>Package Name</label>
    <input type="text" name="pac_name" className="pkg-control" value={formData.pac_name} onChange={handleChange} required />
  </div>

  <div className="col-md-6">
    <label className='package-label'>Days</label>
    <input type="number" name="day" className="pkg-control" value={formData.day} onChange={handleChange} required />
  </div>

  <div className="col-md-6">
    <label className='package-label'>Nights</label>
    <input type="number" name="night" className="pkg-control" value={formData.night} onChange={handleChange} required />
  </div>

  <div className="col-md-6">
    <label className='package-label'>Start Point</label>
    <input type="text" name="start_point" className="pkg-control" value={formData.start_point} onChange={handleChange} required />
  </div>

  <div className="col-md-6">
    <label className='package-label'>Destination Point</label>
    <input type="text" name="dest_point" className="pkg-control" value={formData.dest_point} onChange={handleChange} required />
  </div>

  <div className="col-md-6">
    <label className='package-label'>Accomodation Details ('|' Seperated)</label>
    <input type="text" name="accomodation" className="pkg-control" value={formData.accomodation} onChange={handleChange} required />
  </div>

  <div className="col-md-6">
    <label className='package-label'>Meal Info ('|' Seperated)</label>
    <input type="text" name="meal" className="pkg-control" value={formData.meal} onChange={handleChange} required />
  </div>

  <div className="col-md-6">
    <label className='package-label'>Vehicle Info</label>
    <input type="text" name="vehicle" className="pkg-control" value={formData.vehicle} onChange={handleChange} required />
  </div>

  <div className="col-md-6">
    <label className='package-label'>Sightseeing ('|' Seperated)</label>
    <input type="text" name="sightseeing" className="pkg-control" value={formData.sightseeing} onChange={handleChange} required />
  </div>

  <div className="col-12">
    <label className='package-label'>Package Price</label>
    <input type="number" name="pac_price" className="pkg-control" value={formData.pac_price} onChange={handleChange} required />
  </div>

  <div className="col-12">
    <label className='package-label'>Package Description</label>
    <textarea name="description" rows="4" className="pkg-control" value={formData.description} onChange={handleChange} required />
  </div>

  <div className="col-12">
    <label className='package-label'>Upload Image</label>
    <input type="file" name="image" className="pkg-control" accept="image/*" onChange={handleChange} required />
  </div>

  <div className="col-12 mt-4">
    <button type="submit" className="nav-btn">Submit Package</button>
  </div>

</form>
</div>
{/* package area ends */}

        </div>
      </section>

                  {responseMessage && (
                <div className="response-message d-flex justify-content-between">
                    <p className='my-0 mx-auto'>{responseMessage}</p>
                    <p className='my-0 cursor-pointer' onClick={() => setResponseMessage(false)}> &nbsp;<i class="fa-solid fa-xmark"></i></p>
                </div>)}

    </>
  )
}

export default AddPackage
